import { render } from "./CollectionDetailedSearchHistoricalRecording.vue?vue&type=template&id=684f3037&scoped=true&ts=true"
import script from "./CollectionDetailedSearchHistoricalRecording.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailedSearchHistoricalRecording.vue?vue&type=script&lang=ts"

import "./CollectionDetailedSearchHistoricalRecording.vue?vue&type=style&index=0&id=684f3037&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-684f3037"]])

export default __exports__